import { useQuery } from '@apollo/client/react'
import { GET_SITE_VISITS } from '@/lib/operations/dashboard'
import type { SiteVisitSummary } from '@/lib/types'

export function useSiteVisits(
  clientId: string | null,
  locationId?: string | null,
  filters?: { startDate?: string; endDate?: string }
) {
  const { data, loading, error } = useQuery<{ siteVisits: SiteVisitSummary | null }>(GET_SITE_VISITS, {
    variables: {
      clientId,
      locationId: locationId ?? null,
      startDate: filters?.startDate,
      endDate: filters?.endDate,
    },
    skip: !clientId,
  })
  return { summary: data?.siteVisits ?? null, loading, error }
}
